import { modifier } from 'ember-modifier';

export default modifier((element) => element.showModal());
